module.exports = __webpack_public_path__ + "static/media/octes8h_8.c1dc9bfe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/octes/octes8h_8.svg
// module id = 753
// module chunks = 0